import axios, { AxiosInstance } from "axios";
import ConfigService, { IConfig } from "../../services/ConfigService.ts";

let apiRequester: AxiosInstance | null = null;
let csrfRequester: AxiosInstance | null = null;
export default function setAxiosDefaults() {
  const config = ConfigService.instance;
  axios.defaults.baseURL = config.config.apiUrl;
  axios.defaults.withCredentials = true;
  axios.defaults.withXSRFToken = true;
  apiRequester = axios.create({});
  csrfRequester = axios.create({
    baseURL: config.config.csrfUrl
  });

  config.onLoad((config: IConfig) => {
    axios.defaults.baseURL = config.apiUrl;
    apiRequester = axios.create({});
    csrfRequester = axios.create({
      baseURL: config.csrfUrl
    });
  });
}

export {
  apiRequester,
  csrfRequester
};
